/**
 * Safety mode, slowmode and invite notices, the verified badge (Console v2 §3.4, §3.9, slice S7).
 * i18n/index.ts spreads this table; the slice adds its own keys here.
 */
import type { Dict } from '../core';

export const governanceV2En: Dict = {
  'vb.verified': 'Verified',
  // raid mode, as everyone sees it: calm, no alarm
  'gov.safety.on': 'Safety mode is on for a short while.',
  'gov.safety.body': 'Some things are limited until {time}.',
  'gov.sm.raid': 'Safety mode: you can send a message every {time}',
  'gov.invite.paused': 'Invites are paused for a short while. Try the link again later.',
  // sign-up while raid mode runs, when the console left texts.raid_signups empty (decision 9)
  'gov.signup.pausedTitle': 'Sign-up is paused',
  'gov.signup.paused': 'Sign-up is paused for a short while. Please try again later.',
};
